/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M4.077 9.917A7.926 7.926 0 0 1 11.993 2a7.926 7.926 0 0 1 7.917 7.916c0 5.455-5.452 10.407-7.118 11.795a1.25 1.25 0 0 1-1.598 0c-1.669-1.388-7.117-6.338-7.117-11.794Zm9.166 1.319h2.709a.833.833 0 0 0 0-1.667h-2.709a.417.417 0 0 1-.416-.416V6.444a.833.833 0 0 0-1.667 0v2.709c0 .23-.187.416-.417.416H8.035a.833.833 0 0 0 0 1.667h2.708c.23 0 .417.186.417.416v2.709a.833.833 0 1 0 1.667 0v-2.709c0-.23.186-.416.416-.416Z"
})), "0 0 24 24", "LocationAdd");